import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './AshGourdPage.css';
import ashGourdImage from '../images/ashgourd-logo.png';
import shauryaImage from '../images/ashgourd-shaurya-img.jpeg';

const varieties = [
  {
    name: 'SHAURYA',
    image: shauryaImage,
    description: [
      'Fruit Characteristics: Produces attractive oblong-shaped fruits. The skin is light green when young and turns completely white and waxy at full maturity. The inner flesh is solid white.',
      'Fruit Weight: Typically averages between 5 to 6 kg per fruit.',
      'Maturity & Harvest: The first harvest can be gathered within 110 to 120 days after sowing.',
      'Growth Habit: Features a highly vigorous creeping vine that provides high yield potential and uniform fruit sizes.',
      'Cultivation Seasons: Extremely adaptable and suitable for Kharif (sowing June–July), Rabi (sowing October–November), and Summer seasons.',
    ],
  },
];

export default function AshGourdPage() {
  return (
    <ProductPatternPage
      title="Ash Gourd"
      varieties={varieties}
      pageClass="ashgourd-page"
      heroImage={ashGourdImage}
    />
  );
}
